import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { SaveableWartungsdienstComponent } from '@app/modules/wartungsdienste/saveable-wartungsdienst.component';
import { ACCEPT, ConfirmDialogComponent, ConfirmDialogData } from '@app/shared/dialog/confirm-dialog/confirm-dialog.component';
import { firstValueFrom } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class WartungsdienstNotificationGuard implements CanDeactivate<SaveableWartungsdienstComponent> {
  constructor(private dialog: MatDialog) {}

  canDeactivate(component: SaveableWartungsdienstComponent) {
    if (component && component.hasUnsavedChanges) {
      return firstValueFrom(this.dialog.open(ConfirmDialogComponent, {
          data: {text:            'Wollen Sie die bereits getätigten Eingaben wirklich verwerfen?\n\n' +
                                    'Wenn Sie OK klicken, gehen diese verloren.\n' +
                                    'Wenn Sie ÖFFNEN klicken, wird ein weiteres NV-Cockpit-Fenster geöffnet und die Eingaben bleiben in diesem Fenster erhalten.',
                  showHomeButton: true
                } as ConfirmDialogData
        })
        .afterClosed()
        .pipe(take(1), map(result => result === ACCEPT)));
    }
    return true;
  }
}
